import type { ReactElement, SVGProps } from "react";

/**
 * Universal process glyph — a single vertical squiggle (one mirrored sine
 * period). Shared everywhere a process is represented so the symbol stays
 * consistent across nav rows, tabs, and panes. Drop-in for the lucide icons it
 * replaces: forwards any SVG props (className, strokeWidth, width/height,
 * aria-*). Color via `currentColor`.
 */
export function ProcessGlyph(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M7 0.5 Q11.5 4 7 7 Q2.5 10 7 13.5" />
    </svg>
  );
}
